import client from '@/services/client.js'

const endpoint = 'category'

const allCategories = () => {
  return client.get(endpoint)
}

const specificCategory = id => {
  return client.get(`${endpoint}/${id}`)
}

const createCategory = payload => {
  return client.post(endpoint, payload)
}

const updateCategory = payload => {
  return client.put(endpoint, payload)
}

const deleteCategory = id => {
  return client.delete(endpoint, id)
}

export {
  allCategories,
  specificCategory,
  createCategory,
  updateCategory,
  deleteCategory
}
